import { LoadingButton } from '@mui/lab'
import { Box, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { TraitId } from '@cibo/core'
import { useRollupQuestion } from '@cibo/landmanager'
import { AddInformationNavButtonsProps } from '@cibo/programs'
import { useState } from 'react'
import { FriendlyError } from '../../consts/Theme'

export const ReviewInformationNavButtons = ({
  traitStatuses,
  focusTraitId,
  setFocusTraitId,
  onContinue,
}: AddInformationNavButtonsProps) => {
  const { t } = useTranslation('impact/ProfileFieldsNav')
  const { rollupRequested, commitChanges } = useRollupQuestion()
  const [isUpdating, setIsUpdating] = useState(false)
  const [commitError, setCommitError] = useState<any | undefined>()

  const statuses = traitStatuses

  const currentIndex = statuses?.findIndex(
    (item: { traitId: TraitId }) => item.traitId === focusTraitId
  )

  const stepNav = async (direction: number) => {
    if (!statuses || currentIndex === undefined) {
      return
    }

    if (rollupRequested) {
      setIsUpdating(true)
      try {
        await commitChanges()
        setIsUpdating(false)
      } catch (error) {
        setIsUpdating(false)
        setCommitError(error)
        return
      }
    }

    const nextTrait = statuses[currentIndex + direction]
    if (nextTrait) {
      setFocusTraitId(nextTrait.traitId)
    }
  }

  const handleClickNext = () => {
    stepNav(1)
  }
  const handleClickPrevious = () => {
    stepNav(-1)
  }

  const handleSeeOpportunities = async () => {
    if (rollupRequested) {
      setIsUpdating(true)
      try {
        await commitChanges()
        setIsUpdating(false)
      } catch (error) {
        setIsUpdating(false)
        setCommitError(error)
        return
      }
    }

    onContinue && onContinue()
  }

  return (
    <>
      {!!commitError && <FriendlyError message={t('commitError')} />}

      <Stack direction="row" justifyContent="flex-end" spacing={2}>
        <LoadingButton
          onClick={handleClickPrevious}
          disabled={!(!!currentIndex && currentIndex > 0)}
          loading={isUpdating}
        >
          {t('previous')}
        </LoadingButton>
        <Box sx={{ flex: 1 }} />
        <LoadingButton
          fullWidth={false}
          onClick={handleClickNext}
          disabled={!!currentIndex && currentIndex + 1 === statuses?.length}
          loading={isUpdating}
        >
          {t('next')}
        </LoadingButton>
        <LoadingButton
          fullWidth={false}
          onClick={handleSeeOpportunities}
          variant="contained"
          loading={isUpdating}
        >
          {t('seeOpportunities')}
        </LoadingButton>
      </Stack>
    </>
  )
}
